import React from 'react';
import styled from 'styled-components';
import PropTypes, { shape } from 'prop-types';
import I10n from '../features/i10n';
import Device from '../models/Device';

const Container = styled.div`
`;

const Title = styled.h3`
  margin: 0;
  margin-bottom: 4px;
  padding: 0;
  font-size: 12px !important;
  line-height: 16px !important;
  color: #333333;
  font-weight: bold;
`;

const ConnectionTypesRow = styled.div`
  display: flex;
  flex-direction: row;
`;

const ConnectionTypeOption = styled.div`
  display: flex;
  padding: 5px 10px;
  position: relative;
  background-color: ${props => props.selected ? '#626469' : ''};
  color: ${props => props.selected ? 'white' : ''};
  border: 1px solid ${props => props.selected ? '#626469' : '#E7E6E6'};
  cursor:  ${props => props.isLoading ? 'not-allowed' : 'pointer'};
`;

const ConnectionTypeText = styled.span`
  font-size: 10px;
`;

const ConnectionTypeOptionMask = styled.div`
  position: absolute;
  top: 0; right: 0; bottom: 0; left: 0;
  background-color: grey;
  z-index: 1;
  opacity: 0.2;
`;

class ConnectionTypeSettings extends React.Component {

  static propTypes = {
    module: shape(Device),
    isLoading: PropTypes.bool,
    onConnectionTypeClick: PropTypes.func
  }

  render = () => {
    return (
      <Container>
        <Title>{I10n.get('module_setting.information.connection_type')}</Title>
        <ConnectionTypesRow>
          {this.props.module.relatedConnectionDevices.map(relatedDevice => {
            const isConnectionTypeSelected = this.props.module.electricalConnection === relatedDevice.connectionType;
            return (
              <ConnectionTypeOption
                key={relatedDevice.connectionType}
                selected={isConnectionTypeSelected}
                isLoading={this.props.isLoading}
                onClick={() => {
                  if (!isConnectionTypeSelected) {
                    this.props.onConnectionTypeClick(relatedDevice.referenceID);
                  }
                }}
              >
                <ConnectionTypeText>{I10n.getOrDefault(`connection_type.${relatedDevice.connectionType}`, relatedDevice.connectionType, 'data')}</ConnectionTypeText>
                {this.props.isLoading && <ConnectionTypeOptionMask></ConnectionTypeOptionMask>}
              </ConnectionTypeOption>
            )
          })}
        </ConnectionTypesRow>
      </Container>
    );
  }
}
export default ConnectionTypeSettings;
